export const DEFAULT_PAGE_TITLE = 'Cutwise platform';
export const EMPTY_VALUE_DASH = '—';
export const WEBGL_VERSION = document.createElement('canvas').getContext('webgl2') ? 2 : 1;
export const IS_WEBGL2_AVAILABLE = WEBGL_VERSION === 2;
